import { Image } from '@/atoms/Image'

export function ImgFullParallax() {
  return (
    <section
      className="aspect-square md:aspect-auto relative w-full text-clip md:h-[902px]"
      data-name="img-full-parallax"
    >
      <div className="absolute inset-0 md:left-[-32px] md:top-[-32px] md:h-[966px] md:w-[calc(100%+64px)]">
        <Image
          alt=""
          className="pointer-events-none object-cover"
          src="/v1760543239/theatrical/david/tapestry-bg-img-02.png"
          fill
          sizes="100vw"
          loading="lazy"
        />
      </div>
    </section>
  )
}
